"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scatter = exports.Bubble = exports.Radar = exports.PolarArea = exports.Pie = exports.Line = exports.Doughnut = exports.Bar = exports.defineChartComponent = void 0;
const components_1 = require("./components");
var components_2 = require("./components");
Object.defineProperty(exports, "defineChartComponent", { enumerable: true, get: function () { return components_2.defineChartComponent; } });
exports.Bar = components_1.defineChartComponent('bar-chart', 'bar');
exports.Doughnut = components_1.defineChartComponent('doughnut-chart', 'doughnut');
exports.Line = components_1.defineChartComponent('line-chart', 'line');
exports.Pie = components_1.defineChartComponent('pie-chart', 'pie');
exports.PolarArea = components_1.defineChartComponent('polar-chart', 'polarArea');
exports.Radar = components_1.defineChartComponent('radar-chart', 'radar');
exports.Bubble = components_1.defineChartComponent('bubble-chart', 'bubble');
exports.Scatter = components_1.defineChartComponent('scatter-chart', 'scatter');
exports.default = {
    Bar: exports.Bar,
    Doughnut: exports.Doughnut,
    Line: exports.Line,
    Pie: exports.Pie,
    PolarArea: exports.PolarArea,
    Radar: exports.Radar,
    Bubble: exports.Bubble,
    Scatter: exports.Scatter,
    defineChartComponent: components_1.defineChartComponent,
};
